var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tooltip",
    {
      attrs: { top: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-btn",
                _vm._b(
                  {
                    staticClass: "align-center",
                    attrs: {
                      icon: "",
                      "x-small": _vm.xSmall,
                      color: _vm.color,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.copyToClipboard()
                      },
                    },
                  },
                  "v-btn",
                  attrs,
                  false
                ),
                [
                  _c("v-icon", { attrs: { "x-small": _vm.xSmall } }, [
                    _vm._v(_vm._s(_vm.icon)),
                  ]),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c(
            "v-icon",
            { attrs: { "x-small": _vm.xSmall, left: "", color: "white" } },
            [_vm._v("check")]
          ),
          _vm._v("Copied\n    "),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }